import { render } from "./PickupPointList.vue?vue&type=template&id=5ea3928f"
import script from "./PickupPointList.vue?vue&type=script&lang=js"
export * from "./PickupPointList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__